<template>
    <div>
        <kt-panel-body>
        <kt-nav space="md" size="lg" id="kt-nav">
            <form @submit.prevent="changeSheba" id="changeSehba_form">
                <kt-nav-item>
                    <div class="p-2 mt-2 mr-2" id="changeSheba">
                        <div style="overflow:inherit">
                            <div class="py-1 my-2 h5">
                                <i class="fa fa-credit-card"></i>
                                {{ $t('panel.shaparak-requests.change-sheba') }}
                            </div>
                            <div
                                id="shebaForm"
                                aria-labelledby="shebaForm"
                                data-parent="#changeSheba"
                                v-if="form_data.status === gatewayStatus.ACTIVE"
                            >
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="12" md="12" lg="12">
                                            <kt-form-group>
                                                <kt-form-label for="sheba_number">
                                                    {{ $t('label.sheba_number') }}
                                                </kt-form-label>
                                                <select
                                                        id="sheba_number"
                                                        name="sheba_number"
                                                        v-model="form_data.sheba"
                                                        class="form-control kt-selectpicker"
                                                >
                                                    <option
                                                            v-bind:key="sheba_number.id"
                                                            v-for="sheba_number in sheba_numbers"
                                                            :value="sheba_number.id"
                                                            :selected="checkSelectedShebas(sheba_number.id)"
                                                    >
                                                        {{ sheba_number.number }}
                                                    </option>
                                                </select>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <button class="btn btn-success btn-wide" id="changeSheba_btn">
                                        {{ $t('label.send_request') }}
                                    </button>
                                </kt-form-section>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
        </kt-nav>
        </kt-panel-body>
        <hr>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>


<script>


import $ from "jquery";
import columns from "../datatable/change-requests-columns";
import {mapGetters} from "vuex";
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import { i18n } from '@/plugins/i18n';
import { KTApp } from '@/plugins/core/app'
import {gatewayStatus} from "../../../constants/gatewayStatus";
import { gatewayService } from "@/common/api.service"

export default {
    props: {
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },

    data() {
        return {
            gatewayStatus: gatewayStatus,
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "shaparak_requests_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path(`shaparak/user-change-requests/${this.$route.params.hashid}`),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
                // actions: actions
            }
        },
        ...mapGetters('gateway', {
            gateway: 'form_data',
            status: 'status'
        }),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
    methods: {
        changeSheba(e) {
            let form = $('#changeSehba_form')
            let btn = $('#changeSheba_btn')
            let nav = $('#kt-nav')

            form.validate({
                rules: {
                    sheba_number: {
                        required: true,
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = {
                'sheba_id':this.form_data.sheba,
                'shop_id' : this.$route.params.hashid
            }

            gatewayService.userChangeShebaRequest(params)
                .then(response => {
                    this.showMsg(nav, 'success', response.data.message)
                    this.$refs.datatable.reload()
                })
                .catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(nav, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)
        },
        checkSelectedShebas(id) {
            return this.form_data.sheba.includes(id);
        }
    },
    mounted() {
        this.afterDispatch();
        this.$store.dispatch('shebaNumber/fetch')
    }
}
</script>
